export enum Mode {
  VIEW,
  EDIT_DRAW,
  EDIT_LINE,
  EDIT_TEXT,
}